"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getFromDatabaseFunction_1 = __importDefault(require("./getFromDatabaseFunction"));
const writeToDatabaseFunction_1 = __importDefault(require("./writeToDatabaseFunction"));
const deleteFromDatabaseFunction_1 = __importDefault(require("./deleteFromDatabaseFunction"));
const databaseCore = ({ database, getDatabaseCache, }) => {
    const dbFirebaseListeners = {
        value: [],
        set: (newListeners) => {
            dbFirebaseListeners.value = newListeners;
        },
        push: (newListener) => {
            const listenerFind = dbFirebaseListeners.value.find((objListener) => (newListener.listener === objListener.listener));
            if (!listenerFind) {
                dbFirebaseListeners.value.push(newListener);
            }
        },
    };
    let dbCacheListeners = [];
    const addDbCacheListener = (newListenerRoute, newListenerCallback) => {
        dbCacheListeners.push({
            callback: newListenerCallback,
            route: newListenerRoute,
        });
    };
    return {
        cleanListeners: () => {
            dbFirebaseListeners.value.forEach((objListener) => {
                objListener.dataReference.off('value', objListener.listener);
            });
            dbFirebaseListeners.set([]);
            dbCacheListeners = [];
        },
        delete: (0, deleteFromDatabaseFunction_1.default)({
            database,
        }),
        write: (0, writeToDatabaseFunction_1.default)({
            database,
            getDatabaseCache,
        }),
        read: (0, getFromDatabaseFunction_1.default)({
            database,
            dbFirebaseListeners,
            addDbCacheListener,
            getDatabaseCache,
        }),
    };
};
exports.default = databaseCore;
